import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_PROGRAMME_LIST} from "../../graphql/queries/programme/list";
import {GET_PROGRAMME_GROUPS} from "../../graphql/queries/programme/groups";

const state = {
  programmes: [],
  groups: []
};

const getters = {
  programmesByChannelId: state => id => state.programmes.filter(programme => programme.channel_id === id),
  programmeCountries: state => Object.keys(state.groups),
  programmeSites: state => country => state.groups[country] ? Object.keys(state.groups[country]) : [],
  programmeChannels: state => (country, site) => state.groups[country] && state.groups[country][site] ? state.groups[country][site] : [],
};

const mutations = {
  UPDATE_PROGRAMME_LIST: function (state, programmes) {
    programmes.forEach(programme => {
      state.programmes.upsert({id: programme.id}, programme);
    });
  },
  UPDATE_PROGRAMME_GROUPS: function (state, groups) {
    state.groups = groups;
  }
};

const actions = {
  async programmeFetchList ({commit, dispatch}, input) {
    const {data} = await apolloClient.query({query: GET_PROGRAMME_LIST, variables: {input: input}});
    if (data && data.programmeList) {
      commit('UPDATE_PROGRAMME_LIST', data.programmeList);
    }
  },
  async programmeFetchGroups ({commit}) {
    const {data} = await apolloClient.query({query: GET_PROGRAMME_GROUPS});
    if (data && data.programmeGroups) {
      const response = JSON.parse(data.programmeGroups);
      commit('UPDATE_PROGRAMME_GROUPS', response);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/programme.js